import {NgModule} from '@angular/core';
import {RouterModule, Routes} from '@angular/router';
import {ExamResultComponent} from './exam-result/exam-result.component';


const routes: Routes = [
    {
        path: 'exam-result',
        component: ExamResultComponent,
        data: {title: 'Exam Result'},
    },
    {
        path: 'examination-schedule',
        component: ExamResultComponent,
        data: {title: 'Examination Schedule'},
    },
    {
        path: 'examination-annual-report',
        component: ExamResultComponent,
        data: {title: 'Examination Annual Report'},
    },
    {
        path: 'academic-calender',
        component: ExamResultComponent,
        data: {title: 'Academic Calender'},
    },
    {
        path: 'system-of-grading',
        component: ExamResultComponent,
        data: {title: 'System of Grading'},
    },
    {
        path: 'degree-verification',
        component: ExamResultComponent,
        data: {title: 'Degree Verification'},
    },
    {
        path: 'programme-curriculum',
        component: ExamResultComponent,
        data: {title: 'Program Curriculum'},
    },
    {
        path: 'university-prospectus',
        component: ExamResultComponent,
        data: {title: 'University Prospectus'},
    },
];

@NgModule({
    imports: [RouterModule.forChild(routes)],
    exports: [RouterModule]
})
export class AcademicInfoRoutingModule {
}
